module.exports = __webpack_public_path__ + "static/media/sprite.f8407d5f.svg";